import { faCheck, faLightbulb, faTrash } from '@fortawesome/pro-solid-svg-icons';
import { HateoasResource } from '@lagoshny/ngx-hateoas-client';
import { TranslateService } from '@ngx-translate/core';
import { Status } from 'src/app/shared/models/status.model';
import { Address, CompanyOwned } from '../company/company-models.model';
import { StrategyCodeType } from '../strategy/strategy-code.model';
import { RgsObjectContactPerson } from './rgs-object-contact-person.model';
import { RgsObjectMember } from './rgs-object-member.model';

export interface RgsObjectSimplified {
  id: string;
  bedrijf: string;
  naam: string;
  adres: string;
  adressen: Address[];
}

export enum RgsObjectType {
  UTILITY = 'utiliteit',
  HOUSES = 'woningen',
}

@HateoasResource('rgsobject')
export class RgsObject extends CompanyOwned {
  public adres!: string;
  public bouwjaar!: number;
  public complex!: string;
  public naam!: string;
  public omschrijving!: string;
  public type!: RgsObjectType;
  public vhe!: number;
  public plaats!: string;
  public adressen: Address[] = [];
  public afbeeldingen: RgsObjectPhotos[] = [];
  public members: RgsObjectMember[] = [];
  public contactPersons: RgsObjectContactPerson[] = [];
  public categorien: RgsObjectCategory[] = [];
  public documenten: RgsObjectDocument[] = [];
  public strategien: RgsObjectStrategy[] = [];
  public weblinks: WebLink[] = [];

  //FRONTEND ONLY
  //  TRANSIENT FIELDS
  public owner: string = '';
  public clients: string = '';
  public contractors: string = '';
  public source: string = '';
}

export class RgsObjectPhotos {
  public naam!: string;
  public uniekecode!: string;
}

export class RgsObjectCategory {
  public naam!: string;
  public label!: string;
}

export class RgsObjectDocument {
  public datum!: Date;
  public grootte!: number;
  public naam!: string;
  public type!: string;
  public uniekecode!: string;
  public beschrijving!: string;
  public bedrijf?: string;
  public label?: string;
  public private: boolean | null = null;
}

export class WebLink {
  public omschrijving!: string;
  public weblink!: string;
}

export class RgsObjectStrategy {
  public id?: string;
  public actueel?: boolean;
  public datum!: Date | string;
  public naam!: string;
  public status!: RgsObjectStrategyStatus;
  public versie!: string;
  public categorien: RgsObjectStrategyCategory[] = [];
  public type!: StrategyCodeType;
}

export class RgsObjectStrategyCategory {
  public naam!: string;
  public nummer!: number;
  public vragen: RgsObjectStrategyCategoryQuestion[] = [];
}

export class RgsObjectStrategyCategoryQuestion {
  public naam!: string;
  public nummer!: number;
  public vraagtype!: string;
  public antwoorden: RgsObjectStrategyCategoryQuestionAnswer[] = [];
  public resultaten: RgsObjectStrategyCategoryQuestionAnswer[] = [];
}

export class RgsObjectStrategyCategoryQuestionAnswer {
  public naam!: string;
  public nummer!: number;
}

export const rgsObjectStrategyStatuses = (translateService?: TranslateService) =>
  [
    {
      value: RgsObjectStrategyStatus.CONCEPT,
      label: translateService?.instant(`statuses.${RgsObjectStrategyStatus.CONCEPT}`),
      icon: faLightbulb,
      severity: 'concept-status',
    },
    {
      value: RgsObjectStrategyStatus.DEFINITIVE,
      label: translateService?.instant(`statuses.${RgsObjectStrategyStatus.DEFINITIVE}`),
      icon: faCheck,
      severity: 'definitive-status',
    },
    {
      value: RgsObjectStrategyStatus.ARCHIVE,
      label: translateService?.instant(`statuses.${RgsObjectStrategyStatus.ARCHIVE}`),
      icon: faTrash,
      severity: 'archive-status',
    },
  ] as Status<RgsObjectStrategyStatus>[];

export enum RgsObjectStrategyStatus {
  CONCEPT = 'concept',
  DEFINITIVE = 'definitief',
  ARCHIVE = 'archief',
}
